import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {CommonUtils} from "../../utils/common";
import {ScheduledEmail} from "../../models/scheduled-email.model";

@Component({
  selector: 'app-scheduled-emails-details',
  templateUrl: './scheduled-emails-details.component.html',
  styleUrls: ['./scheduled-emails-details.component.scss'],
})
export class ScheduledEmailsDetailsComponent implements OnInit {


  @Input() scheduledEmails: ScheduledEmail[];
  @Input() title;

  constructor(private modalController: ModalController,
              private commonUtils: CommonUtils) {
  }

  ngOnInit() {
  }

  onClose() {
    this.modalController.dismiss();
  }

  translateScheduledEmailEventType(type: string) {
    return this.commonUtils.getTranslatedScheduledEmailEventLabel(type);
  }
}
